<template>
	<div>
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div class="min-h-screen bg-gray-50 pb-20">
			<div class="fixed top-0 w-full bg-white shadow-md z-50 px-4 py-3">
				<button @click="queryPruchasedPackages"
					:class="[ '!rounded-button w-full py-3 flex items-center justify-center gap-2',isConnected ? 'bg-green-500 text-white' : 'bg-red-500 text-white']">
					<i :class="['fas', isConnected ? 'fa-link' : 'fa-unlink']"></i>
					{{ isConnected ? $t('language000421') : $t('language000422') }}
				</button>
			</div>

			<div class="pt-20 px-4" :class="{ 'opacity-50 pointer-events-none': !isConnected }">
				<div class="bg-white rounded-xl shadow-sm p-4 mb-4">
					<h2 class="text-lg font-medium mb-4">
						<!-- 模式选择 -->
						{{ $t('language000423') }}
					</h2>

					<div class="mb-6">
						<div class="flex items-center justify-between mb-4">
							<span class="text-base">
								<!-- 震动模式 -->
								{{ $t('language000424') }}
							</span>

							<el-switch style="display: block" @change="toggleVibration" v-model="vibrationEnabled"
								active-color="#13ce66" inactive-color="#999" :active-text="$t('language000363')">
							</el-switch>

						</div>

						<div class="grid grid-cols-5 gap-2 mb-4">
							<button v-for="mode in 5" :key="`vib-${mode}`" @click="selectVibrationMode(mode)"
								:class="[ '!rounded-button py-2 text-sm', vibrationMode === mode ? 'bg-blue-500 text-white' : 'bg-gray-100' ]">
								<!-- 模式选择 -->
								{{ $t('language000423') }}{{ mode }}
							</button>
						</div>

						<div class="px-2">
							<input type="range" v-model="vibrationIntensity" min="1" max="5"
								class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
							<div class="flex justify-between text-xs text-gray-500 mt-1">
								<span>1</span>
								<span>2</span>
								<span>3</span>
								<span>4</span>
								<span>5</span>
							</div>
						</div>
					</div>

					<div>
						<div class="flex items-center justify-between mb-4">
							<span class="text-base">
								<!-- 吸吮模式 -->
								{{ $t('language000425') }}
							</span>

							<el-switch style="display: block" @change="setSuckingStrength" v-model="suctionEnabled"
								active-color="#F66EB8" inactive-color="#999" :active-text="$t('language000363')">
							</el-switch>

						</div>

						<div class="grid grid-cols-5 gap-2 mb-4">
							<button v-for="mode in 5" :key="`suc-${mode}`" @click="selectSuctionMode(mode)"
								:class="[ '!rounded-button py-2 text-sm', suctionMode === mode ? 'bg-blue-500 text-white' : 'bg-gray-100' ]">
								<!-- 模式选择 -->
								{{ $t('language000423') }}{{ mode }}
							</button>
						</div>

						<div class="px-2">
							<input type="range" v-model="suctionIntensity" min="1" max="5"
								class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
							<div class="flex justify-between text-xs text-gray-500 mt-1">
								<span>1</span>
								<span>2</span>
								<span>3</span>
								<span>4</span>
								<span>5</span>
							</div>
						</div>
					</div>
				</div>

				<div class="bg-white rounded-xl shadow-sm p-4">
					<h2 class="text-lg font-medium mb-4">
						<!-- 线性控制 -->
						{{ $t('language000426') }}
					</h2>

					<div class="mb-6">
						<div class="flex items-center justify-between mb-4">
							<span class="text-base">
								<!-- 震动强度 -->
								{{ $t('language000427') }}
							</span>

							<el-switch style="display: block" @change="linearOpening" v-model="linearVibrationEnabled"
								active-color="#13ce66" inactive-color="#999" :active-text="$t('language000363')">
							</el-switch>

						</div>

						<div class="px-2">
							<input type="range" @input="handleLinearVibrationChange" v-model="linearVibrationIntensity"
								min="1" max="100"
								class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
							<div class="flex justify-between text-xs text-gray-500 mt-1">
								<span>1</span>
								<span>25</span>
								<span>50</span>
								<span>75</span>
								<span>100</span>
							</div>
						</div>
					</div>

					<div>
						<div class="flex items-center justify-between mb-4">
							<span class="text-base">
								<!-- 吸吮强度 -->
								{{ $t('language000428') }}
							</span>

							<el-switch style="display: block" @change="suckingOpening" v-model="linearSuctionEnabled"
								active-color="#13ce66" inactive-color="#999" :active-text="$t('language000363')">
							</el-switch>
						</div>

						<div class="px-2">
							<input type="range" @input="suckingLinearVibrationChange" v-model="linearSuctionIntensity"
								min="1" max="100"
								class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
							<div class="flex justify-between text-xs text-gray-500 mt-1">
								<span>1</span>
								<span>25</span>
								<span>50</span>
								<span>75</span>
								<span>100</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				toyId: "", //传递过来的值 设备ID
				receiverID: "", //传递过来的值 生成链接的ID
				uuid: "", //传递过来的值 uuid 唯一标识
				isConnected: false, //设备是否成功连接

				vibrationEnabled: false, //长摇尾部 是否开启
				vibrationMode: 1, //震动模式1~5
				vibrationIntensity: 1, //震动力度1~5

				suctionEnabled: false, //长摇头部 是否开启
				suctionMode: 1, //吸吮模式
				suctionIntensity: 1, //吸吮力度

				linearVibrationEnabled: false, //线性尾部 是否开启
				linearVibrationIntensity: 1, //线性力度

				linearSuctionEnabled: false, //线性头部 是否开启
				linearSuctionIntensity: 1, //线性力度

				command: "" //发送给APP的蓝牙命令
			};
		},
		mounted() {
			this.toyId = this.$route.params.toyId; //设备ID
			this.receiverID = this.$route.params.receiverID; //生成链接的ID
			this.uuid = this.$route.params.uuid; //uuid 唯一标识

			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
		},
		methods: {
			queryPruchasedPackages() { //H5查询App是否已连接设备
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/getAppConnectToyStatus/' + this.toyId, {}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("H5查询App是否已连接设备：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							if (response.data.data.appConnectStatus == 0) { //app端连接设备的状态 默认0未连接，1已连接
								this.open4(this.$t('language000429')); //APP未连接设备
								this.isConnected = false;
							}
							if (response.data.data.appConnectStatus == 1) { //app端连接设备的状态 默认0未连接，1已连接
								this.isConnected = true;
								this.pushMsgToApp("mqtt_100008") //推送
							}
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//长摇震动模式
			toggleVibration(newValue) {
				this.queryPruchasedPackages()
				this.vibrationEnabled = newValue
				if (newValue) { //长摇 震动 开启
					this.generatePulseBirdLongSwayModelTail_h5() //开始震动
				} else {
					this.generatePulseBirdStopAllShakeTail_h5() //停止震动
				}
			},
			selectVibrationMode(mode) { //震动模式的选择
				this.queryPruchasedPackages()
				this.vibrationMode = mode;
				if (this.vibrationEnabled) {
					this.generatePulseBirdLongSwayModelTail_h5() //开始震动
				}
			},
			generatePulseBirdLongSwayModelTail_h5() { //长摇的尾部开启
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/generatePulseBirdLongSwayModelTail_h5', {
						toyId: this.toyId,
						userId: this.receiverID,
						vibrationIntensity: this.vibrationIntensity, //震动强度
						vibrationMode: this.vibrationMode //震动模式
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("长摇的尾部开启：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_100007") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//长摇吸吮模式
			setSuckingStrength(newValue) {
				this.queryPruchasedPackages()
				this.suctionEnabled = newValue
				if (newValue) { //长摇 吸吮 开启
					this.PulseBirdLongSwayModelHead_h5() //开始吸吮
				} else {
					this.generatePulseBirdStopAllHeadShakeHead_h5() //停止吸吮
				}
			},
			selectSuctionMode(mode) { //吸吮模式的选择
				this.queryPruchasedPackages()
				this.suctionMode = mode;
				if (this.suctionEnabled) {
					this.PulseBirdLongSwayModelHead_h5() //开始吸吮
				}
			},
			PulseBirdLongSwayModelHead_h5() { //长摇的头部开启
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/PulseBirdLongSwayModelHead_h5', {
						toyId: this.toyId,
						userId: this.receiverID,
						vibrationIntensity: this.vibrationIntensity, //震动强度
						vibrationMode: this.vibrationMode //震动模式
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("长摇的头部开启：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_100007") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//线性尾部
			linearOpening(newValue) {
				this.queryPruchasedPackages()
				this.linearVibrationEnabled = newValue
				if (newValue) { //线性 震动 开启
					this.generatePulseBirdLineSwayModelTail_h5() //开始震动
				} else {
					this.generatePulseBirdStopAllShakeTail_h5() //停止震动
				}
			},
			handleLinearVibrationChange(event) {
				this.queryPruchasedPackages()
				this.linearVibrationIntensity = parseInt(event.target.value); //转换为整数，因为 range input 的值是字符串
				if (this.linearVibrationEnabled) {
					this.generatePulseBirdLineSwayModelTail_h5() //开始震动
				}
			},
			generatePulseBirdLineSwayModelTail_h5() { //线性的尾部开启
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/generatePulseBirdLineSwayModelTail_h5', {
						toyId: this.toyId,
						userId: this.receiverID,
						speedValue: this.linearVibrationIntensity, //速度值
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("线性的尾部开启：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_100007") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//线性头部
			suckingOpening(newValue) {
				this.queryPruchasedPackages()
				this.linearSuctionEnabled = newValue
				if (newValue) { //线性 吸吮 开启
					this.generatePulseBirdLineSwayModelHead_h5() //开始吸吮
				} else {
					this.generatePulseBirdStopAllHeadShakeHead_h5() //停止吸吮
				}
			},
			suckingLinearVibrationChange(event) {
				this.queryPruchasedPackages()
				this.linearSuctionIntensity = parseInt(event.target.value); //转换为整数，因为 range input 的值是字符串
				if (this.linearSuctionEnabled) {
					this.generatePulseBirdLineSwayModelHead_h5() //开始吸吮
				}
			},
			generatePulseBirdLineSwayModelHead_h5() { //线性的头部开启
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/generatePulseBirdLineSwayModelHead_h5', {
						toyId: this.toyId,
						userId: this.receiverID,
						speedValue: this.linearSuctionIntensity, //速度值
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("线性的头部开启：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_100007") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},

			//----------------------------------------------------------------------------------------------------------------------------------------------
			//尾部停止 头部停止 发送mqtt给APP
			generatePulseBirdStopAllShakeTail_h5() { //尾部停止
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/generatePulseBirdStopAllShakeTail_h5', {
						toyId: this.toyId,
						userId: this.receiverID
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("尾部停止：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_100007") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			generatePulseBirdStopAllHeadShakeHead_h5() { //头部停止
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/generatePulseBirdStopAllHeadShakeHead_h5', {
						toyId: this.toyId,
						userId: this.receiverID
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("头部停止：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_100007") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			pushMsgToApp(mqttType) { //推送给APP
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/pushMsgToApp', {
						toyUid: this.toyId,
						receiverID: this.receiverID,
						command: this.command,
						mqttType: mqttType
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("推送给APP：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态

						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			open2(string) {
				this.$message({
					message: string,
					type: 'success'
				});
			},
			open4(string) {
				this.$message.error(string);
			},
			//...
		},
	};
</script>

<style scoped>
	input[type="range"] {
		-webkit-appearance: none;
		appearance: none;
		background: transparent;
		cursor: pointer;
	}

	input[type="range"]::-webkit-slider-runnable-track {
		background: #ddd;
		height: 8px;
		border-radius: 4px;
	}

	input[type="range"]::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		margin-top: -4px;
		background-color: #3b82f6;
		height: 16px;
		width: 16px;
		border-radius: 50%;
	}

	input[type="range"]:focus {
		outline: none;
	}

	input[type="range"]::-moz-range-track {
		background: #ddd;
		height: 8px;
		border-radius: 4px;
	}

	input[type="range"]::-moz-range-thumb {
		border: none;
		border-radius: 50%;
		background-color: #3b82f6;
		height: 16px;
		width: 16px;
	}
</style>